import { QRCodeStorage } from "../initializeQRCode/QRCode";
export var getQRCode = function getQRCode() {
  var _QRCodeStorage$getIns;
  return (_QRCodeStorage$getIns = QRCodeStorage.getInstance().getData().qrCode) !== null && _QRCodeStorage$getIns !== void 0 ? _QRCodeStorage$getIns : '';
};